import NewProject from './new-project.js';

export default NewProject;
